module.exports = __webpack_public_path__ + "static/media/icon-heart.0c5c27ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-heart.svg
// module id = 521
// module chunks = 0